import { Component, Input } from '@angular/core';
import { WorkflowStateType } from 'situview-webapi-client';

@Component({
  selector: 'product-workflow-icon',
  templateUrl: './product-workflow-icon.component.html',
  styleUrls: ['./product-workflow-icon.component.scss']
})
export class ProductWorkflowIconComponent {
  
  @Input() workflowStateType: WorkflowStateType = WorkflowStateType.InProgress;

  workflowStateTypeEnum = WorkflowStateType;

  constructor() {
      
  }

}